import React from "react";
import orglogo from '../../assets/img/orglogo.png'
import Loader from '../../utils/Loader';
import avatar from "../../assets/img/profile_av.jpg";


function Outsourced({ user, sums, tasks }) {
    return (
        <div className="row dash-row d-flex">
            <div className="col-md-6 col-sm-6 col-12">
                <div className="card employee-welcome-card flex-fill mt-1">
                    <div className="card-body">
                        {(user && user.first_name) ? <>
                        <div className="welcome-info">
                            <div className="welcome-content">
                                <h5 style={{textTransform:'capitalize'}}>Hello, {user && user.first_name} {user && user.last_name}</h5>
                                <p>Welcome to your profile.</p>
                            </div>
                            <div className="welcome-img">
                                <img src={avatar} className="img-fluid" alt="User" />
                            </div>
                        </div>
                        <div className="welcome-btn">
                            <a href="/my/profile" className="btn">View Profile</a>
                        </div>
                        </>: <Loader /> }
                    </div>
                </div>

                <div className="profilebox mb-4">
                    <div className="logobox">
                        <img src={orglogo} className="" alt="logo" width={40} height={40} />
                    </div>
                    <div className="namebox">
                        <h4>{(user && user.organization) ? `${user && user.organization?.name}` : 'loading...'}</h4>
                    </div>
                    <div className="detailbox">
                        <p><span className="title">Company ID</span> 
                            <span className="det">RC999933</span>
                        </p>
                        <p><span className="title">Address</span> 
                            <span className="det">Victoria Island, Lagos</span>
                        </p>
                    </div>
                </div>
            </div>

            <div className="col-md-6 col-sm-6 col-12">
                <div className="card flex-fill mt-1 task_statistics">
                    <div className="card-body">
                        <h5 className="card-title font-weight-bold">Task Statistics</h5>
                        <div className="statistics">
                            {tasks && tasks.length > 0 ? 
                            <div className="row">
                                {tasks && tasks.map((task, i) => (
                                    <div className="col-md-6 col-6 text-center" key={i}>
                                        <div className="stats-box">
                                            <p>{task.name && task.name}</p>
                                            <h3 className={task.className && task.className}>
                                                {task.count && task.count}
                                            </h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : <Loader /> }
                        </div>
                    </div>
                </div>

                <div className="card flex-fill mt-4 mb-4 task_statistics">
                    <div className="card-body">
                        <h5 className="card-title font-weight-bold">Attendance and Leave</h5>
                        <div className="statistics">
                            {sums && sums.length > 0 ? 
                            <div className="row">
                                {sums && sums.map((sum,i) => (
                                    <div className="col-md-4 col-4 text-center" key={i}>
                                        <div className="stats-box">
                                            <p>{sum.name && sum.name}</p>
                                            <h3 className={sum.className && sum.className}>
                                                {sum.count && sum.count}
                                            </h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Outsourced;